import { MspSortDirection, MspSortType } from 'models/claims'

import {
  createClaimCaseSlice,
  Status,
  ClaimCaseReducer,
  createClaimCaseGetters
} from 'redux/helpers/claimCase'

export const {
  getStatus,
  getAllSearchResults,
  getSearchResultsTotal,
  getSearchResults,
  getSortType,
  getSortDirection
} = createClaimCaseGetters('msp')

export const initialState: ClaimCaseReducer = {
  results: [],
  searchResultsPage: 1,
  sortType: MspSortType.INCIDENT_DATE,
  sortDirection: MspSortDirection.DESC,
  status: Status.IDLE
}

export const mspSlice = createClaimCaseSlice({
  name: 'msp',
  initialState: initialState,
  reducers: {}
})

export const {
  showMoreSearchResults,
  showAllSearchResults,
  sortCases
} = mspSlice.actions

export default mspSlice.reducer
